import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import { EhrAppointmentAttendanceChargeKind } from '@src/types'
import { appointmentKindSelector } from '@src/selectors/app'
import { AppStackParamList } from '@src/navigation/types'
import { EhrAppointmentCustomType } from '@src/screens/NutritionistHub/utils'
import { Card } from './Card'
import { CalendarIcon } from './CalendarIcon'

interface PendingCallCardProps {
  pendingAppointment: Pick<EhrAppointmentCustomType, 'id' | 'title' | 'kind'>
  chargeKind: EhrAppointmentAttendanceChargeKind
  onScheduleNextCall?: () => void
}

export const PendingCallCard = ({
  pendingAppointment,
  chargeKind,
  onScheduleNextCall,
}: PendingCallCardProps) => {
  const navigation = useNavigation()
  const appointmentKind = useSelector(appointmentKindSelector(pendingAppointment.kind))

  if (!appointmentKind) {
    return null
  }

  const isFree = chargeKind === EhrAppointmentAttendanceChargeKind.BsFree

  const appointmentTitle = pendingAppointment.title
    ? pendingAppointment.title
    : `${appointmentKind.coachingKind.serviceTitle} Call`

  const title = isFree ? `Free ${appointmentKind.coachingKind.serviceTitle} Call` : appointmentTitle
  const buttonTitle = isFree ? 'Schedule your free call' : 'Schedule your call'

  const schedulePendingAppointment = () => {
    const { id: pendingAppointmentId, kind: appointmentKind } = pendingAppointment

    const navigationParams: AppStackParamList['CallScheduling'] = {
      appointmentKind,
      pendingAppointmentId,
      allowBackNavigation: true,
    }
    navigation.navigate('CallScheduling', navigationParams)
  }

  return (
    <Card
      icon={<CalendarIcon variant="check" />}
      title={title}
      description="Find a time that works for you"
      buttonTitle={buttonTitle}
      onCardPress={schedulePendingAppointment}
      onButtonPress={onScheduleNextCall || schedulePendingAppointment}
    />
  )
}
